<template>
    <div>
        <app-sub-title text="Minutas creadas por supervisores"></app-sub-title>
        <app-notebook-of-supervisors-filters
            @filter="onFilter"
            :authors="authors"
            :types-annotation="annotationTypes"
        />
        <app-notebook-of-supervisors-list
            :data="data"
            @change-page="onChangePage"
            @sort="onSort"
        />
    </div>
</template>

<script>
import NotebookOfSupervisorsList from './NotebookOfSupervisorsList/NotebookOfSupervisorsList.vue';
import NotebookOfSupervisorsFilters from './NotebookOfSupervisorsFilters/NotebookOfSupervisorsFilters.vue';
import notebookRepository from '../../../../repositories/notebook.repository';
import { mapGetters } from 'vuex';

export default {
    components: {
        appNotebookOfSupervisorsList: NotebookOfSupervisorsList,
        appNotebookOfSupervisorsFilters: NotebookOfSupervisorsFilters
    },
    data(){
        return {
            data: {},
            sort: {
                sortBy: 'created_at',
                sortDir: 'desc'
            },
            authors: [],
            filters: {},
            page: 1,
        }
    },
    computed: {
        ...mapGetters(['annotationTypes'])
    },
    methods: {
        loadNotes() {
            const filters = {...this.filters, sortBy: this.sort.sortBy, sortDir: this.sort.sortDir};
            const nr = {...notebookRepository};
            nr
                .getNotesBySupervisors(filters, this.page)
                .then(data => {
                    const notes = data.data;
                    const fNotes = notes.map(item => {
                        const _rowDetails = true;
                        return {...item, _rowDetails};
                    });                
                    const theData = {...data, data: fNotes};
                    this.data = theData;
                })
                .catch(error =>
                    toastr.error("Ocurrió un error al cargar las notas")
                );
        },
        loadAuthorsAnnotations() {
        const nr = {...notebookRepository};
        nr
            .getAuthorsSupervisors()
            .then(data => (this.authors = data))
            .catch(error =>
                toastr.error( "Ocurrió un error al cargar los autores de las anotaciones")
            );
        },
        onFilter(filters){
            this.filters = filters;
            this.loadNotes();
        },
        onChangePage(page){
            this.page = page;
            this.loadNotes();
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy;
            this.sort.sortDir = ctx.sortDir;
            this.loadNotes();
        },
        initialize(){
            this.loadAuthorsAnnotations();
            this.load('annotationTypes');
            this.loadNotes();
        }
    },
    created(){
        this.initialize();
    }
}
</script>

<style>

</style>
